import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { setColorTheme } from 'theme/utils/generic-helpers'
import * as Sentry from '@sentry/gatsby'

export const sendInBlueSubscribe = async (
  email,
  source,
  urlPage,
  checkedLists,
  commentsNotes,
  firstName,
  lastName,
  position,
  company,
  country,
  state,
) => {
  const data = {
    EMAIL: email,
    FIRSTNAME: firstName,
    LASTNAME: lastName,
    POSITION: position,
    COMPANY: company,
    SOURCE: source,
    SUBSCRIBE__PAGE: urlPage,
    GDPR: true,
    email_address_check: '',
    email2: commentsNotes,
    locale: 'en',
    html_type: 'simple',
    IP_ADDRESS: '',
    checkedLists,
  }
  if (commentsNotes) {
    // catch honey pot
    return
  }
  try {
    const response = await fetch('https://jsonip.com', { mode: 'cors' })
    const resp = await response.json()
    const ipDataReq = await fetch('https://ipinfo.io/' + resp.ip + '?token=371c690a69d8f4', { mode: 'cors' })
    const ipData = await ipDataReq.json()
    // console.log(resp.ip, ipData)
    data.IP_ADDRESS = resp.ip
    data.city = ipData.city
    data.country = country || ipData.country
  } catch (e) {
    Sentry.captureMessage('failed to get IP: ' + email + ' from: ' + source)
    // console.log('e', e)
  }

  // const stringData = encodeURIComponent(JSON.stringify(data).replace('{', '').replace('}', ''))
  //   .replace(/%22/g, '')
  //   .replace(/%3A/g, '=')
  //   .replace(/%2C/g, '&')

  // const requestOptions = {
  //   method: 'POST',
  //   headers: {
  //     'Content-Type': 'application/x-www-form-urlencoded',
  //   },
  //   body: stringData + '&lists_38[]=' + encodeURIComponent(JSON.stringify(checkedLists)),
  // }

  // const url =
  //   'https://9c863001.sibforms.com/serve/MUIEAHhQt47tGJ7ssFalk3RcP1lhm5nmdsy_xfrZ9R8jUFFuPSJJcuumuQKQKCz02RwMXtYpXgSqlvRt4xuXfFoq2JqmDfBAOjcnzizu9MMohTPFXw7D1arxSeXfNRUYnExiZIM2rGoBxqtHBwYHzbM9PU3g7OW0oC3yRJLod2QlN58ku9hGZ3p-wuS4ggVdUv0UukpSJZ6i5TEr'

  try {
    // fetch(url, requestOptions)
    fetch('https://hook.eu1.make.com/cgxlg8knvvavj5gdcj8qhq4y85vqhe4e', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
  } catch (e) {
    Sentry.captureMessage('failed to subscribe: ' + email + ' from: ' + source)
  }
}

function Subscribe({ id, options, color, theme, blogSubscription }) {
  const [sending, setSending] = React.useState(false)
  const [error, setError] = React.useState('')
  const [validationError, setValidationError] = React.useState('')
  const [success, setSuccess] = React.useState('')

  const urlPage = typeof window !== 'undefined' ? window.location.href : ''
  const emailId = id + '-subscribe-email'
  const newsletterIds = {
    emea: 20,
    europe: 20,
    usa: 21,
    apac: 19,
    newsletter: 6,
  }

  const validateForm = () => {
    // make sure at least one box is ticked
    let oneChecked = false
    options.forEach((option) => {
      if (document.getElementById(option.name + id).checked) oneChecked = true
    })
    if (options.length > 0 && !oneChecked) {
      setValidationError(true)
      return false
    }
    return true
  }

  const submitForm = async (e) => {
    e.preventDefault()
    const validForm = validateForm()
    if (validForm) {
      setError('')
      setValidationError('')
      const email = document.getElementById(emailId)
      const commentsNotes = document.getElementById(id + '-subscribe-notes')
      // get the checked options
      const checkedLists = options
        .map((option) => {
          if (document.getElementById(option.name + id).checked) return newsletterIds[option.name]
        })
        .filter((option) => {
          return option !== undefined
        })
      // SENDING CODE
      try {
        setSending(true)
        await sendInBlueSubscribe(email.value, id, urlPage, checkedLists, commentsNotes.value)

        // tidy up form
        email.value = ''

        options.forEach((option) => {
          document.getElementById(option.name + id).checked = false
        })

        setSending(false)
        setSuccess(true)
      } catch (e) {
        setSending(false)
        setError(e.message)
      }
    }
  }
  return (
    <div>
      <form onSubmit={submitForm}>
        <div>
          <label htmlFor={emailId} className="sr-only">
            Email address
          </label>
          <input
            type="email"
            id={emailId}
            required
            className={`appearance-none min-w-0 w-full bg-white border  rounded-md py-2 px-4 text-base leading-6 
          text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-gray focus:placeholder-gray-400 transition duration-150 ease-in-out
          ${theme === 'light' ? 'border-gray-900' : 'border-transparent'}
        `}
            placeholder="Enter your email"
          />

          <label htmlFor={`${id}-subscribe-notes`} className="hidden">
            Comments:
          </label>
          <input
            id={`${id}-subscribe-notes`}
            type="text"
            placeholder="Comments_Notes"
            name="CommentsNotes"
            className="hidden"
          />
        </div>

        <div className="pl-4 mt-6">
          {options.map((option) => {
            return (
              <div
                key={option.name}
                className={`${option.default ? 'hidden' : ''} flex items-center mb-4 mt-2`}
              >
                <input
                  id={option.name + id}
                  type="checkbox"
                  checked={option.default}
                  readOnly={option.default}
                  className={`form-checkbox h-4 w-4 mr-2 text-indigo-600 transition duration-150 ease-in-out
                  ${theme === 'light' ? 'border border-gray-900' : ''}
                `}
                />
                <label
                  htmlFor={option.name + id}
                  className={`}ml-2 block text-sm leading-5 
                  ${theme === 'light' ? 'text-gray-900' : 'text-gray-100'}
                `}
                >
                  {option.title}
                </label>
              </div>
            )
          })}
        </div>

        {validationError && (
          <div className="rounded-md bg-red-50 p-4 mb-4">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg
                  className="h-5 w-5 text-red-400"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <div className="ml-3">
                <h3 className="text-sm leading-5 font-medium text-red-800">Please select a box above</h3>
                <div className="mt-2 text-sm leading-5 text-red-700">
                  <p>Otherwise we don&apos;t know what to keep you up to date on</p>
                </div>
              </div>
            </div>
          </div>
        )}

        {error && (
          <div className="rounded-md bg-red-50 p-4 mb-4">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg
                  className="h-5 w-5 text-red-400"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <div className="ml-3">
                <h3 className="text-sm leading-5 font-medium text-red-800">Uh Oh!</h3>
                <div className="mt-2 text-sm leading-5 text-red-700">
                  <p>Let us know in the chat what went wrong and we&apos;ll try to fix it</p>
                </div>
              </div>
            </div>
          </div>
        )}
        {success && (
          <div className="rounded-md bg-green-50 p-4 mb-4">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg
                  className="h-5 w-5 text-green-400"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <div className="ml-3">
                <h3 className="text-sm leading-5 font-medium text-green-800">Sent!</h3>
                <div className="mt-2 text-sm leading-5 text-green-700">
                  <p>Please confirm your email to complete the subscription.</p>
                </div>
              </div>
            </div>
          </div>
        )}
        {!blogSubscription && (
          <div>
            <div className="mt-3 rounded-md sm:mt-0 sm:flex-shrink-0">
              <button
                type="submit"
                disabled={sending}
                className={`${
                  sending
                    ? setColorTheme(
                        'bg-emea-300 border-emea-300 bg-apac-300 border-apac-300 bg-community-300 border-community-300 bg-usa-300 border-usa-300 ',
                        color,
                      )
                    : setColorTheme(
                        'bg-emea-500 border-emea-500 bg-community-500 border-community-500 bg-apac-500 border-apac-500 bg-usa-500 border-usa-500',
                        color,
                      )
                } 
            w-full border rounded-md py-2 px-4 flex items-center justify-center text-base leading-6 font-medium  text-white
            ${setColorTheme(
              'hover:bg-emea-600 focus:border-emea-600 focus:ring-emea active:bg-emea-600 hover:bg-apac-600 focus:border-apac-600 focus:ring-apac active:bg-apac-600 hover:bg-community-600 focus:border-community-600 focus:ring-community active:bg-community-600 hover:bg-usa-600 focus:border-usa-600 focus:ring-usa active:bg-usa-600',
              color,
            )} 
            ${theme === 'light' ? 'bg-uxdx-700 hover:bg-uxdx-500' : ''}
            focus:outline-none transition duration-150 ease-in-out`}
              >
                {sending ? 'Sending...' : 'Subscribe'}
              </button>
            </div>
            <p
              className={`mt-3 text-sm leading-5 
          ${theme === 'light' ? 'text-gray-700' : 'text-indigo-100'}
        `}
            >
              We care about the protection of your data. Read our{' '}
              <Link
                to="/privacy"
                className={`font-medium underline ${theme === 'light' ? 'text-gray-500' : 'text-white'} `}
              >
                Privacy Policy.
              </Link>
            </p>
          </div>
        )}
      </form>
    </div>
  )
}

Subscribe.propTypes = {
  theme: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      default: PropTypes.bool,
    }),
  ),
  id: PropTypes.string.isRequired,
  color: PropTypes.string,
  blogSubscription: PropTypes.bool,
}

export default Subscribe
